// extracted by mini-css-extract-plugin
module.exports = {"button":"Button_button__mg_cR","icon":"Button_icon__IvYNF","iconContainer":"Button_iconContainer__K2GSz"};